/// <amd-module name="Build/Admin/Common/Actions/ResourceLimitActions" />
import { Action } from "VSS/Reflux/Action";

import { ResourceLimit } from "DistributedTask/Client/Contracts/TaskAgent";

import { StoreStatus } from "Build/Admin/Common/Constants";

export class ResourceLimitActions {
    public resourceLimitsUpdated = new Action<ResourceLimit[]>();
    public resourceLimitsStatusUpdated = new Action<StoreStatus>();
}
